import { Map } from 'mapbox-gl';
import type { MapRef } from 'react-map-gl/mapbox';

/**
 * Calculates mapRotation for use in explore-service queries.
 * map.getBearing() returns degrees from N clockwise from -180 -> 180 but mapRotation uses 0 -> 360.
 * @param map Mapbox map object
 * @returns mapRotation
 */
const getMapRotation = (map: Map | MapRef) => {
  let mapRotation = map.getBearing();
  if (mapRotation < 0) {
    mapRotation += 360;
  }
  return mapRotation;
};

export default getMapRotation;
